import React from "react";
import "./App.css";
import Header from "./Header.js";
import Introduction from "./Introduction";
import About from "./About";
import Skills from "./Skills";
import Footer from "./Footer";  
import { useRef } from "react";

function App() {
    const aboutRef = useRef();
    const homeRef = useRef();
    const skillsRef = useRef();
    return (
        <>
            <Header
                aboutRef={aboutRef}
                homeRef={homeRef}
                skillsRef={skillsRef}
            />
            <div className="main">
                <Introduction
                    homeRef={homeRef}
                    myName="Nikhil Mandaliya."
                    myIntro="As a developer, my superpower happens behind the scenes to make a website look great, work fast and perform well with a seamless user experience."
                />
                <About aboutRef={aboutRef} />
                <Skills skillsRef={skillsRef} />
            </div>
            <Footer />
        </>
    );
}

export default App;
